import React from 'react';
import { Line } from 'react-chartjs-2';

export default function TotalRewards({ stats }) {
  return (
    <section className={'shadow p-5 bg-white'}>
      <div className={'flex flex-row justify-between'}>
        <div>
          <h3 className={'font-medium text-base lg:text-lg'}>Total Rewards</h3>
        </div>
        <div>
          <h3 className={'text-sm text-gray-400'}>Current Week</h3>
          <h3
            className={
              'mt-1 lg:mt-2 text-lg lg:text-xl font-medium text-gray-800'
            }
          >
            {stats && stats.total_rewards_current_week} rewards
          </h3>
        </div>
        <div>
          <h3 className={'text-sm text-gray-400'}>Previous Week</h3>
          <h3
            className={
              'mt-1 lg:mt-2 text-lg lg:text-xl font-medium text-gray-500'
            }
          >
            {stats && stats.total_rewards_previous_week} rewards
          </h3>
        </div>
      </div>
      <Line
        data={{
          labels: stats && Object.keys(stats.total_rewards),
          datasets: [
            {
              label: 'Rewards',
              data: stats && Object.values(stats.total_rewards),
              fill: false,
              backgroundColor: 'rgb(255, 99, 132)',
              borderColor: 'rgba(255, 159, 64, 1)',
            },
          ],
        }}
        options={{
          scales: {
            x: {
              display: true,
              title: {
                display: true,
                text: 'Days',
              },
            },
            y: {
              display: true,
              title: {
                display: true,
                text: 'Rewards',
              },
            },
          },
        }}
      />
    </section>
  );
}
